import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BookingCalendar from './components/BookingCalendar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import RealEstate from './pages/industries/RealEstate';
import Education from './pages/industries/Education';
// import './App.css'; // Temporary - contains invalid imports

function App() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const openBooking = () => setIsBookingOpen(true);
  const closeBooking = () => setIsBookingOpen(false);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header onBookMeeting={openBooking} />
        <main>
          <Routes>
            <Route path="/" element={<Home onBookMeeting={openBooking} />} />
            <Route path="/about" element={<About onBookMeeting={openBooking} />} />
            <Route path="/services" element={<Services onBookMeeting={openBooking} />} />
            <Route path="/industries/real-estate" element={<RealEstate onBookMeeting={openBooking} />} />
            <Route path="/industries/education" element={<Education onBookMeeting={openBooking} />} />
            <Route path="/blogs" element={<Blogs onBookMeeting={openBooking} />} />
            <Route path="/contact" element={<Contact onBookMeeting={openBooking} />} />
            {/* Placeholder routes for other pages */}
            <Route path="/smb-login" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-2xl">SMB Login - Coming Soon</h1></div>} />
            <Route path="/snapshot-report" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-2xl">Snapshot Report - Coming Soon</h1></div>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
        <BookingCalendar isOpen={isBookingOpen} onClose={closeBooking} />
      </div>
    </Router>
  );
}

export default App;

